export var Order;
(function (Order) {
    let Type;
    (function (Type) {
        Type["Sequential"] = "SEQUENTIAL";
        Type["Divergent"] = "DIVERGENT";
        Type["Cyclic"] = "CYCLIC";
    })(Type = Order.Type || (Order.Type = {}));
    let Sequential;
    (function (Sequential) {
        function make() {
            return { type: "SEQUENTIAL" };
        }
        Sequential.make = make;
    })(Sequential = Order.Sequential || (Order.Sequential = {}));
    let Divergent;
    (function (Divergent) {
        function make() {
            return { type: "DIVERGENT" };
        }
        Divergent.make = make;
    })(Divergent = Order.Divergent || (Order.Divergent = {}));
    let Cyclic;
    (function (Cyclic) {
        function make() {
            return { type: "CYCLIC" };
        }
        Cyclic.make = make;
    })(Cyclic = Order.Cyclic || (Order.Cyclic = {}));
})(Order || (Order = {}));
